import React, { FC } from 'react';
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Link,
} from '@mui/material';
import { Visibility, Add } from '@mui/icons-material';
import { useStyles } from '../styles';

interface DrawerResourceProps {
  url?: string | null;
  sectionsIds?: string[];
  onSectionClick: (sectionId: string) => void;
}

export const DrawerResource: FC<DrawerResourceProps> = ({
  url,
  sectionsIds = [],
  onSectionClick,
}) => {
  const classes = useStyles();
  return (
    <List>
      {url && (
        <ListItem
          button
          component={Link}
          href={url}
          target="_blank"
          className={classes.link}
        >
          <ListItemIcon className={classes.listItemIcon}>
            <Visibility />
          </ListItemIcon>
          <ListItemText primary="Voir l'article" />
        </ListItem>
      )}
      {sectionsIds.map((sectionId: string, i: number) => (
        <ListItem button key={i} onClick={() => onSectionClick(sectionId)}>
          <ListItemIcon className={classes.listItemIcon}>
            <Add />
          </ListItemIcon>
          <ListItemText primary={`Ajouter l'article à la section ${i + 1}`} />
        </ListItem>
      ))}
    </List>
  );
};
